<template>
  <div class="home">
    <div style="text-align: right; padding: 10px">
      <el-button type="primary" @click="back" plain>后退</el-button>
    </div>
    <div class="content">
      <el-row :gutter="12">
        <el-col>
          <el-button :span="24" size="medium" @click="echartsRouter()"
            >分层审核看板</el-button
          >
        </el-col>
        <el-col :span="24">
          <el-button size="medium" @click="planRouter()"
            >审核计划矩阵</el-button
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../../router";
export default {
  name: "home",
  data() {
    return {
      msg: "home",
      all: false,
    };
  },
  mounted() {
    // 初始化
    var type = this.$route.query.type;
    this.all = type == "all";
  },
  methods: {
    echartsRouter() {
      if (this.all) {
        router.push("/layeraudit/board?type=all");
      } else {
        router.push("/layeraudit/board");
      }
    },
    planRouter() {
      router.push("/layeraudit/plan");
    },
    back() {
      router.back();
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/layeraudit/category/category.vue